import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
  padding: 16px;

  @media (max-width: 480px) {
    align-items: flex-end;
    padding: 0;
  }
`;

export const Content = styled.div`
  background: white;
  border-radius: 12px;
  width: 100%;
  max-width: 400px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);

  @media (max-width: 480px) {
    border-radius: 12px 12px 0 0;
    max-height: 85vh;
    margin-top: auto;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  border-bottom: 1px solid #eee;
  background: #f8f9fa;
  border-radius: 12px 12px 0 0;

  .header-content {
    display: flex;
    align-items: center;
    gap: 12px;

    h3 {
      margin: 0;
      color: #333;
      font-size: 18px;
      font-weight: 600;
    }
  }

  .close-button {
    background: none;
    border: none;
    padding: 8px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
      background: rgba(229, 57, 53, 0.1);
    }
  }
`;

export const Form = styled.form`
  padding: 20px;

  @media (max-width: 480px) {
    padding: 16px;
  }

  .info-section {
    margin-bottom: 20px;
    padding: 15px;
    background: #f0f8ff;
    border-radius: 8px;
    border-left: 4px solid #01579b;

    p {
      margin: 0;
      color: #333;
      font-size: 14px;

      strong {
        color: #01579b;
      }
    }
  }

  .button-group {
    display: flex;
    gap: 12px;
    margin-top: 24px;

    @media (max-width: 380px) {
      flex-direction: column;
      gap: 8px;
    }
  }
`;

export const InputGroup = styled.div`
  margin-bottom: 20px;

  label {
    display: block;
    margin-bottom: 8px;
    color: #333;
    font-weight: 500;
    font-size: 14px;
  }

  input {
    width: 100%;
    padding: 12px 16px;
    border: 2px solid #ddd;
    border-radius: 8px;
    font-size: 16px;
    transition: border-color 0.2s;
    box-sizing: border-box;

    &:focus:not(:disabled) {
      outline: none;
      border-color: #01579b;
      box-shadow: 0 0 0 3px rgba(1, 87, 155, 0.1);
    }

    &::placeholder {
      color: #999;
    }

    &:disabled {
      background-color: #f5f5f5;
      color: #666;
      cursor: not-allowed;
      opacity: 0.7;
    }
  }
`;

export const CheckboxGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;

  input {
    width: 18px;
    height: 18px;
    margin: 0;
  }

  label {
    margin: 0;
    color: #333;
    font-weight: 500;
    font-size: 14px;
    cursor: pointer;
  }
`;

export const Button = styled.button`
  flex: 1;
  background: #01579b;
  color: white;
  border: none;
  padding: 14px 20px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.2s;

  &:hover:not(:disabled) {
    background: #004c8b;
  }

  &:active:not(:disabled) {
    transform: translateY(1px);
  }

  &:disabled {
    background: #ccc;
    cursor: not-allowed;
    opacity: 0.7;
  }
`;

export const CancelButton = styled.button`
  flex: 1;
  background: #f5f5f5;
  color: #666;
  border: 2px solid #ddd;
  padding: 14px 20px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;

  &:hover:not(:disabled) {
    background: #e0e0e0;
    border-color: #bbb;
  }

  &:active:not(:disabled) {
    transform: translateY(1px);
  }

  &:disabled {
    background: #f9f9f9;
    color: #999;
    cursor: not-allowed;
    opacity: 0.7;
  }
`;
